module.exports = __webpack_public_path__ + "img/illucourse.191b25f1.jpg";